import { makeRequestAction } from './index';

export const fetchConsultantsCategories = makeRequestAction('FETCH_CONSULTANTS_CATEGORIES', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
